import { Store } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SurveyOptionsComponent } from '../../shared/survey/survey-options/survey-options.component';
import { QuestionSetComponent } from '../../shared/survey/question-set/question-set.component';
import { SurveysService } from '@app/services/api/surveys/surveys.service';
import { Survey } from '@app/schemas/surveys';
import { setSurvey } from '@app/state/actions/surveys.action';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxSpinnerModule } from "ngx-spinner";
import { DebugModeService } from '@app/services/debug-mode.service';
import { SurveyStorageService } from '@app/services/local-storage/survey-storage.service';

@Component({
  selector: 'app-career-survey',
  imports: [
    SurveyOptionsComponent,
    QuestionSetComponent,
    NgxSpinnerModule,
  ],
  templateUrl: './career-survey.component.html',
  styleUrl: './career-survey.component.css'
})
export class CareerSurveyComponent implements OnInit {
  showOptions: boolean = false;
  showQuestionSet: boolean = false;
  public currentStep: number = 0;
  public loadingMessage: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: SurveysService,
    private store: Store<{ survey: Survey }>,
    private spinner: NgxSpinnerService,
    private debugModeService: DebugModeService,
    private surveyStorageService: SurveyStorageService,
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(queryParams => {
      this.debugModeService.activate(queryParams['debug'] ?? null);
    });

    this.route.params.subscribe(params => {
      const step = params['step'] ? parseInt(params['step']) : 0;
      this.setCurrentStep(step);
    });

    this.spinner.show();
    setTimeout(() => {
      this.loadingMessage = 'Loading, please wait…';
    });
    const surveyUuid = environment.careerSurveyUuid;

    this.apiService.getSurvey(surveyUuid).subscribe({
      next: (response) => {
        this.processAPIResults(response);
      },
      error: (error) => {
        console.error('Error fetching survey questions:', error);
        this.spinner.hide();
        this.loadingMessage = 'Failed to load survey. Please try again.';
      }
    });
  }

  processAPIResults(data: Survey) {
    const survey: Survey = data;

    this.store.dispatch(setSurvey({ survey }));
    
    if (this.currentStep === 0) {
      this.showOptions = true;
    }
    
    this.spinner.hide();
    this.loadingMessage = 'Survey loaded.';
  }

  private setCurrentStep(step: number) {
    this.currentStep = step;
    this.resetAllSteps();
    
    if (step >= 1) {
      this.showQuestionSet = true;
    } else {
      this.showOptions = true;
    }
  }

  private resetAllSteps() {
    this.showOptions = false;
    this.showQuestionSet = false;
  }

  showSurveyOptions(e: boolean) {
    if (e) {
      this.router.navigate(['/survey']);
    }
  }

  updateQuestionSetView(e: boolean) {
    if (e) {
      this.surveyStorageService.setSurveyStarted();
      this.router.navigate(['/survey/1']);
    } else {
      this.router.navigate(['/survey']);
    }
  }

  navigateToStep(step: number) {
    if (step === 0) {
      this.router.navigate(['/survey']);
    } else {
      this.router.navigate(['/survey/' + step]);
    }
  }
}
